<template>
  <div class="d-flex justify-space-between">
    <div class="d-flex align-center">
      <ClosdFildersIcon :document="file"
                        :signed-file="itemIsSignedOnClosd"
                        class="mr-1"
      />

      <div>
        <p class="ma-0 text--small">
          {{ file.name }}
        </p>
        <p class="text-grey-500 ma-0 text--x-small">
          <app-filesize-display :value="file.size"/>
        </p>
      </div>
    </div>

    <app-button 
      type="icon"
      @click="$emit('delete-file', file)"
    >
      <app-material-icon name="close" />
    </app-button>
  </div>
</template>

<script>
import ClosdFildersIcon from '@/common/filders/ClosdFildersIcon.vue'

export default {
  name: 'ArchivesUploadedFileListItem',
  components: { ClosdFildersIcon },
  emits: ['delete-file'],
  props: {
    file: {
      type: [File, Object],
      required: true,
    },
  },
  computed: {
    itemIsSignedOnClosd () {
      return this.file.signedOnClosd
    },
  },
}
</script>
